import React, {memo, useCallback, useMemo, useState} from 'react';

import './index.scss';
import {PasswordContainer} from '../../../../components/PasswordContainer';
import {useSelector} from 'react-redux';
import {SettingsPageContainer} from '../../../../components/Settings/SettingsPageContainer';
import {ColumnModel, SettingsList} from '../../../../components/Settings/SettingsList';
import {CameraModel} from '../../../../types/control';
import {useSetSelector} from '../../../../hooks/set-selector';

const columns: ColumnModel[] = [
    {
        length: 3,
        name: 'Kamera Adı',
        key: 'name',
    },
    {
        length: 2,
        name: 'Marka',
        key: 'camera_brand_id',
    },
];

const keyExtractor = (item: CameraModel) => item.id;

export const CameraListScreen = memo(function CameraListScreen() {
    const cameraList = useSelector(state => state.control.cameraList);
    const cameraBrandSet = useSetSelector(state => state.control.cameraBrandList);

    const [selectedCamera, setSelectedCamera] = useState<CameraModel>(null);

    const buttons = useMemo(() => [
        {
            text: 'DÜZENLE',
            url: `/settings/camera/edit/${selectedCamera ? selectedCamera.id : ''}`,
            className: 'orange',
            hidden: !(selectedCamera),
        },
        {
            text: 'Kamera OLUŞTUR',
            url: '/settings/camera/edit',
            className: 'green',
        },
    ], [selectedCamera]);

    const displayNameExtractor = useCallback((item: CameraModel, column: ColumnModel) => {
        if (column.key === 'camera_brand_id') {
            return cameraBrandSet[item.camera_brand_id].name;
        }

        return item[column.key] || '-';
    }, [cameraBrandSet]);

    return (
        <PasswordContainer requiredRole="service" isFullscreen={true}>
            <SettingsPageContainer buttons={buttons} className="camera-list-page" backUrl={'/settings'}>
                <SettingsList
                    columns={columns}
                    items={cameraList}
                    displayNameExtractor={displayNameExtractor}
                    keyExtractor={keyExtractor}
                    selectedItem={selectedCamera}
                    onItemSelected={setSelectedCamera}/>
            </SettingsPageContainer>
        </PasswordContainer>
    );
});
